import { Dispatch, SetStateAction, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'

import ROUTES from 'app/routes'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import ConfirmModal from 'components/Modal/ConfirmModal'
import { RegularModerate } from 'components/Typography'
import { commonMessages } from 'app/i18n/messages'
import { JobInfoHeaderMenuMessages } from '../messages'
import { deleteJobThunk } from 'features/jobs/slice'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { JobPageContext } from 'features/jobs/JobPageContext'

interface DeleteJobModalProps {
  setIsDeleteJobOpen: Dispatch<SetStateAction<boolean>>
  setError: Dispatch<SetStateAction<object | undefined>>
}
function DeleteJobModal({ setIsDeleteJobOpen, setError }: DeleteJobModalProps) {
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()
  const history = useHistory()
  const rootDomainId = useAppSelector(currentRootDomainIdSelector)
  const { jobName, jobId } = useContext(JobPageContext)

  const handleDeleteJob = async () => {
    try {
      await dispatch(deleteJobThunk({ domainId: jobId }))
      setIsDeleteJobOpen(false)
      history.push(ROUTES.homesJobs(rootDomainId))
    } catch (err) {
      console.log('Error deleting job', err)
      setError(err)
      setIsDeleteJobOpen(false)
    }
  }

  return (
    <ConfirmModal
      isOpen
      onDiscard={() => setIsDeleteJobOpen(false)}
      onConfirm={handleDeleteJob}
      title={formatMessage(JobInfoHeaderMenuMessages.deleteModalTitle)}
      discardBtnTitle={formatMessage(commonMessages.cancel)}
      confirmBtnTitle={formatMessage(commonMessages.delete)}
      variant="errorFilled"
    >
      <RegularModerate>
        {formatMessage(JobInfoHeaderMenuMessages.deleteModalMessage, {
          jobName,
          br: <br />,
        })}
      </RegularModerate>
    </ConfirmModal>
  )
}

export default DeleteJobModal
